import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { forwardRef, useContext, useRef } from "react";
import { useCombineRefs } from "../hooks/useCombineRefs";
import * as Styled from "./StickyWrapper.styled";
import { useStickyContext } from "./useStickyContext";
import { useIsMinViewportSize } from "./useIsMinViewportSize";
import { StickyContext } from "./StickyContext";
export const StickyWrapper = forwardRef((props, refProp) => {
    const { children, isDisabled: isDisabledProp, className, isExcludedFromOffsets = false, style, ghostRef: ghostRefProp, contentRef, minViewportHeight, minViewportWidth, parentRef, withoutDropShadow, isOverlay = false, zIndex, ...otherProps } = props;
    const styleProps = { className, style };
    const ref = useRef(null);
    const ghostRef = useRef(null);
    const positionerRef = useRef(null);
    const sizerRef = useRef(null);
    // TODO: fix that this looks at full viewport and not particular container
    // this is a dirty hack to not have to rewrite useIsMinViewportSize, getStickerState and all dependent code just yet
    const { verticalScrollParentRef } = useContext(StickyContext);
    const isMinViewportSize = useIsMinViewportSize({
        minViewportHeight: verticalScrollParentRef ? 0 : minViewportHeight,
        minViewportWidth: verticalScrollParentRef ? 0 : minViewportWidth
    });
    const isDisabled = process.env.NODE_ENV === "test" || isDisabledProp || !isMinViewportSize;
    // Context
    useStickyContext({
        wrapperRef: ref,
        ghostRef,
        positionParentRef: parentRef,
        positionerRef,
        sizerRef,
        isExcludedFromOffsets,
        isOverlay,
        zIndex,
        isDisabled
    });
    // TODO: this likely doesn't work properly with nested refs, consider cloning with cloneNode() in layout effect instead
    // it should have _relatively_ the same performance penalty as rendering two times, minus all the extra JS
    const ghostChildrenWithoutRef = React.isValidElement(children)
        ? React.cloneElement(children, { ref: null, "aria-hidden": true, tabIndex: -1 })
        : children;
    const combinedRef = useCombineRefs(ref, refProp);
    const combinedGhostRef = useCombineRefs(ghostRef, ghostRefProp);
    return (_jsxs(Styled.StickyWrapper, { "data-testid": "StickyWrapper", ref: combinedRef, ...otherProps, children: [_jsx(Styled.Positioner, { "data-testid": "StickyWrapperPositioner", ref: positionerRef, children: _jsx(Styled.Sizer, { hasDropShadow: !withoutDropShadow, ref: sizerRef, children: _jsx("div", { "data-testid": "StickyWrapperContent", ...styleProps, ref: contentRef, children: children }) }) }), _jsx(Styled.Ghost, { "data-testid": "StickyWrapperGhost", ref: combinedGhostRef, "aria-hidden": "true", ...styleProps, children: ghostChildrenWithoutRef })] }));
});
StickyWrapper.displayName = "StickyWrapper";
